// Community wheels that can be downloaded from download.dopove.com. The list in iceCommunityWheels.json is the
// source of truth: every option on the Download page is derived from it, so a link cannot point at a file that
// was not built. Update the JSON when the release pipeline publishes new wheels.
import manifest from "./iceCommunityWheels.json";

export const ICE_VERSION = manifest.version;

export const PLATFORMS = [
  { id: "linux_x86_64", label: "Linux x86_64", tag: "manylinux2014_x86_64" },
  { id: "linux_arm64", label: "Linux ARM64", tag: "manylinux2014_aarch64" },
  { id: "mac_arm64", label: "macOS Apple Silicon", tag: "macosx_11_0_arm64" },
  { id: "mac_x86_64", label: "macOS Intel", tag: "macosx_11_0_x86_64" },
  { id: "windows", label: "Windows x64", tag: "win_amd64" },
];

export const PYTHON_VERSIONS = [
  { id: "310", label: "Python 3.10" },
  { id: "311", label: "Python 3.11" },
  { id: "312", label: "Python 3.12" },
];

const parse = (filename) => {
  const m = filename.match(/^ice_community-[\d.]+-cp(\d+)-cp\d+-(.+)\.whl$/);
  const platform = m && PLATFORMS.find((p) => p.tag === m[2]);
  if (!platform) throw new Error(`Unrecognised wheel in iceCommunityWheels.json: ${filename}`);
  return { filename, python: m[1], platform: platform.id, url: manifest.baseUrl + filename };
};

const ALL = manifest.files.map(parse);

export const wheels = () => ALL;
export const pythonVersionsFor = (platform) => ALL.filter((w) => w.platform === platform).map((w) => w.python).sort();
export const wheelFor = (platform, python) => ALL.find((w) => w.platform === platform && w.python === python);
export const urlFor = (platform, python) => wheelFor(platform, python)?.url;
